// extracted by mini-css-extract-plugin
export default {"state-icon":"state-icon_state-icon__B7XT7"};